module.exports = __webpack_public_path__ + "1c6e228f14c6ba81dee2ea11bf058370.svg";